/*******************product Qutantity 5 or 10****************/

jQuery(document).ready(function(){
  
  var qty_pu=$('.qtycount').val();
  setTimeout(function() {
    if(qty_pu !=1)
      $(".product-pricing .price__current .money").append("<span> each</span>");    
 }, 1000);
  if(qty_pu !=1){
    $(".product-pricing .qty_text_show").append("Must Order in Multiples of "+qty_pu);
  }
  
  $(document).on('click', '.qtyplus', function(e) {
    qtyplus($(this));
  });

  $(document).on('click', '.qtyminus', function(e) {
    qtyminus($(this));
  });

    $(document).on('change', '.qtycount', function(e) {
            var qty_class=$(this).parent().siblings().attr('class');
            var qty_Val=$(this).parent().siblings().find('.quantity').val();
            var total_qty=$(this).closest('form').find('.total_inventory_qty').val();

            var qtyval=parseInt(qty_Val);
            var total_qty=parseInt(total_qty);

              
            if($(this).closest('form').find('.'+qty_class).length){
              var qty = parseInt($(this).val());
              
              
              if(qty==0)
                  price_change(qtyval,qtyval);

              if(qty > total_qty){
                $(this).val(total_qty);
                $(this).closest('form').find('p.qty_info1').addClass('qty_error_message');
                price_change(total_qty,qtyval);
              }
              
              else if(qty !=='' && qty% qtyval == 0 && qty>=qtyval){
                $(this).closest('form').find('button').prop('disabled', false);
                $(this).closest('form').find('button').removeClass('disabled');
                $(this).closest('form').find('p').first().removeClass('qty_error_message');
                price_change(qty,qtyval);
              }
              else{ 
                 $(this).closest('form').find('button').prop('disabled', true);
                 $(this).closest('form').find('button').addClass('disabled');
                 $(this).closest('form').find('p').first().addClass('qty_error_message');
             }
            } else {
              $(this).closest('form').find('button').prop('disabled', false);
               $(this).closest('form').find('button').removeClass('disabled');
               $(this).closest('form').find('p').first().removeClass('qty_error_message');
            }
    });
  
  function qtyplus(thisObj){
    // Get the field name
      fieldName = thisObj.attr('field');
      var current_Val =thisObj.siblings().find('input[name='+fieldName+']').val();
      var qty_Val=thisObj.siblings().find('.quantity').val();
      var total_qty=thisObj.closest('form').find('.total_inventory_qty').val();
      var currentVal = parseInt(current_Val);
      var qtyVal = parseInt(qty_Val);
      var total_qty = parseInt(total_qty);

    if(currentVal%qtyVal != 0)
     {
       var rem_val= Math.floor(currentVal/qtyVal);
       var newval=(rem_val*qtyVal)+qtyVal;
     }
     else
      var newval=currentVal+qtyVal;
    
    if (!isNaN(currentVal)) {
         
      // Increment (if product qutantity is more than inventory products)
     // console.log(newval+"="+total_qty);
       if(newval > total_qty){
          thisObj.closest('form').find('.qtyplus').prop('disabled', true);
          thisObj.closest('form').find('input[name='+fieldName+']').val(total_qty);
          thisObj.closest('form').find('p.qty_info1').addClass('qty_error_message');
          price_change(total_qty,qtyVal);

        }
        else{
            thisObj.closest('form').find('.qtyplus').prop('disabled', false);
            thisObj.closest('form').find('input[name='+fieldName+']').val(newval);
            thisObj.closest('form').find('p.qty_info1').removeClass('qty_error_message');
            price_change(newval,qtyVal);
        }
      
        if(newval%qtyVal==0 && newval >= qtyVal)
		 {
    		  thisObj.closest('form').find('button').prop('disabled', false);
              thisObj.closest('form').find('button').removeClass('disabled');
              thisObj.closest('form').find('p').first().removeClass('qty_error_message');
        }
        else
		{
    		thisObj.closest('form').find('button').prop('disabled', true);
            thisObj.closest('form').find('button').addClass('disabled');
            thisObj.closest('form').find('p').first().addClass('qty_error_message');
        }
      }
     else {
          // Otherwise put a 0 there
          thisObj.closest('form').find('input[name='+fieldName+']').val(qtyVal);
      }
 }

  function qtyminus(thisObj){
      fieldName = thisObj.attr('field');
      var current_Val =thisObj.siblings().find('input[name='+fieldName+']').val();
      var qty_Val=thisObj.siblings().find('.quantity').val();
      var total_qty=thisObj.closest('form').find('.total_inventory_qty').val();

      var currentVal = parseInt(current_Val);
      var qtyVal = parseInt(qty_Val);
      var total_qty = parseInt(total_qty);
     if(currentVal%qtyVal != 0)
     {
        var rem_val= Math.floor(currentVal/qtyVal);
        var newvals=rem_val*qtyVal;
     }
     else if(currentVal > qtyVal){
       var newvals=currentVal - qtyVal;
     }
    // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > qtyVal) {

          // Decrement val
        if(newvals > total_qty){
          thisObj.closest('form').find('input[name='+fieldName+']').val(total_qty);
          thisObj.closest('form').find('p.qty_info1').addClass('qty_error_message');
          price_change(total_qty,qtyVal);

        }
         else if(newvals<=qtyVal){
            thisObj.closest('form').find('input[name='+fieldName+']').val(qtyVal);
            price_change(newvals,qtyVal);
         }
         else{
             thisObj.closest('form').find('input[name='+fieldName+']').val(newvals);
             price_change(newvals,qtyVal);
          }
                    
        thisObj.closest('form').find('.qtyplus').prop('disabled', false);
        thisObj.closest('form').find('p.qty_info1').removeClass('qty_error_message');


        if(newvals%qtyVal==0)
       {
		   thisObj.closest('form').find('button').prop('disabled', false);
           thisObj.closest('form').find('button').removeClass('disabled');
           thisObj.closest('form').find('p').first().removeClass('qty_error_message');
        }
        else
		{
           thisObj.closest('form').find('button').prop('disabled', true);
           thisObj.closest('form').find('button').addClass('disabled');
           thisObj.closest('form').find('p').first().addClass('qty_error_message');

        }
    }else {
          // Otherwise put a 0 there
            thisObj.closest('form').find('input[name='+fieldName+']').val(qtyVal);
      }
  }
    
});

function price_change(qty,qtyval){
  var price=$('.input_price').val();
  
  /*if(qty==qtyval)
    var subtotal=(price)/100;
  else*/
    var subtotal=(qty * price)/100;
  console.log(qty+"="+price);
  
 $('#code_div_price').text('SubTotal : $'+subtotal.toFixed(2));
  
}

  // check quantity in collection page
    $(document).on('change', '.col_qty', function(e) {
     var qty=$(this).val();
     var name = $(this).attr("name");
     var elem=$(this).parent().siblings ('div.productitem--actions').children('div.atc--button').find('button');
     var total_qty=$(this).parent().siblings('.total_inventory_qty').val();
      var qty_val=0;
      var qty=parseInt(qty);
      var total_qty=parseInt(total_qty);

      if(qty > total_qty){
      
          $(this).val(total_qty);
          $(this).siblings('p').hide();
          $(this).siblings('p.msg').show();
          $(this).siblings('p.msg').addClass('qty_error_message');               
    }
    else{
       if(name=="quantity5")
         qty_val=5;
       if(name=="quantity-10")
         qty_val=10;
       
       if(name=="quantity5" || name=="quantity-10"){
         //console.log(elem);
         if(qty !=='' && qty% qty_val == 0 && qty>0){
             $(elem).removeClass ('disabled');
             $(elem).prop('disabled', false);
              $(this).siblings('p').show();
              $(this).siblings('p.msg').hide();
             $(this).siblings('p').removeClass('qty_error_message');
            }
            else{
              $(elem).addClass ('disabled');
            	$(elem).prop('disabled', true);
                $(this).siblings('p').show();
                $(this).siblings('p.msg').hide();
        		$(this).siblings('p').addClass('qty_error_message');
      	}
       }
       else{
         $(elem).removeClass ('disabled');
         $(elem).prop('disabled', false);
         $(this).siblings('p').removeClass('qty_error_message');
       }
      // alert(qty +" ="+ name);

    }
      
   });


/**************** header filter *******************/
$(document).ready(function(){

   $('.mobile_filter_btn div').on('click', function(){
    $(".bg_nav").toggleClass('box-hover');
     $(".sub_custom_menu").show();
    });
  
   $('.site-header-actions li').on('click', function(){
    $(".bg_nav").toggleClass('box-hover');
    });
  
  $('.filter_box, .filter_box1').hide();
    $('.headTwo_block.one').on('click', function(){
      $('.filter_box1').hide();
      $('.popup_outer').show();
      $('.filter_box').show();
    });
    $('.headTwo_block.two').on('click', function(){
      $('.filter_box').hide();
      $('.popup_outer').show();
      $('.filter_box1').show();
    });
    $('.filter_close, .filter_close1').click(function(){
      $('.popup_outer').hide();
      $('.filter_box, .filter_box1').hide();
      $('.bg_nav').hide();
    });



    $('.close_popup').on('click', function(){
      $('.overlay_closePopup').hide();
      $('.product_popupOuter').hide();
    });


$("#star-rating__write-reviews").click(function(){
  $('html, body').animate({
        scrollTop: $("#reviews_tabC").offset().top
    }, 2000);
});

$("#star-rating__total-reviews").click(function(){
   $('html, body').animate({
        scrollTop: $("#reviews_tabC").offset().top
    }, 2000);
});

$("#prod_seemore").click(function(){
    $('html, body').animate({
        scrollTop: $("#description_tabC").offset().top
    }, 2000);
});

        // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
/* product information feedback code */
 $("#product-information-survey").click(function(){
   $('#image_survey_iframe').css('display', 'none');
   $('#info_survey_iframe').css('display', 'block');
   $(".popup-overlay, .popup-content").addClass("active");
 });
  
 $("#product-imagegallery-survey").click(function(){
   $('#info_survey_iframe').css('display', 'none');
   $('#image_survey_iframe').css('display', 'block');
   $(".popup-overlay, .popup-content").addClass("active");
 });
 
  $(".survey_modal_close").on("click", function(){
   $(".popup-overlay, .popup-content").removeClass("active");
});

/* cart term and condition code */
  
    $('#agree').click(function() {
      if($(this).prop('checked')) {
         $(".term_error").text(" ");  // checked
      } 
      else{
         $(".term_error").text("You must agree with the terms and conditions of sales to check out.");
       }
    });
  
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(".term_error").text(" ");
        $(this).submit();
      }
      else {
        $(".term_error").text("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });


        
}); 

/* After Page Load */
jQuery(document).ready(function() {
    setTimeout(function() {
        if($.trim($(".shopify-app-block div").html())=='')
        {  
          $(".product-ratings").css("display", "block");
       }
    }, 7000);
    
});

// When the user clicks anywhere outside of the modal, close it
/*window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}*/


   